<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div
        class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription"
      >
        <div class="modal-header">
          <svg
            @click="close"
            aria-label="Close modal"
            class="btn-cross clickable"
            viewBox="0 0 100 100"
          >
            <path
              style="fill:#E7ECED;"
              d="M 11.353296,99.60087 C 10.158652,99.2886 9.777993,98.969958 5.6977643,94.866972 2.1057207,91.254898 1.8304722,90.952618 1.4852896,90.24071 0.81477748,88.857864 0.81105034,87.29604 1.4749676,85.913833 1.8282131,85.178419 2.2844961,84.709318 19.173051,67.71852 L 36.508541,50.278081 18.925209,32.657969 C 9.2543694,22.966907 1.2302061,14.855055 1.0937227,14.631624 0.41213551,13.515821 0.15046462,11.993643 0.44367211,10.850191 0.78290636,9.5272428 0.88490944,9.402275 5.0075514,5.258931 7.1356118,3.1201823 9.0858095,1.2352303 9.3413268,1.0701527 10.765399,0.15011615 12.606359,0.04347386 14.201289,0.78862952 14.819598,1.0775028 15.962205,2.1990248 32.609529,18.857231 L 50.358546,36.617837 67.650099,19.29943 C 77.160452,9.7743007 85.147032,1.8489971 85.398046,1.6876364 c 1.55419,-0.9990684 3.787417,-0.98652366 5.286503,0.0297 0.260637,0.1766771 2.183978,2.0121569 4.274096,4.0788374 3.591793,3.5515215 3.820368,3.7993782 4.167595,4.5192852 0.694383,1.439636 0.72604,2.858533 0.09617,4.310142 -0.249317,0.574588 -1.426922,1.778419 -17.770837,18.166619 L 63.947739,50.343479 81.309931,67.677001 c 9.549196,9.533438 17.471827,17.516324 17.605839,17.739747 0.921169,1.535767 1.004823,3.303207 0.230734,4.874735 -0.318635,0.646893 -0.709061,1.068801 -4.336329,4.685967 -4.257301,4.245426 -4.384968,4.350041 -5.683009,4.656488 -1.163701,0.274734 -2.42262,0.119665 -3.466787,-0.427051 C 85.26288,98.998765 81.147235,94.938683 67.725487,81.514131 L 50.306479,64.091491 32.887759,81.514359 C 19.456606,94.948716 15.350941,98.999012 14.953153,99.207113 c -1.078967,0.564456 -2.395801,0.708488 -3.599857,0.393757 z"
            />
          </svg>
        </div>
        <div class="modal-body">
          <slot name="body">Graph is not available.</slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  width: 100%;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 10px;
  margin: 0;
  align-items: center;
  background-color: #008080;
  color: #ffffffff;
}

.btn-cross {
  height: 15px;
  cursor: pointer;
  float: right;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}
</style>
